import React from "react";
import { useSelector } from "react-redux";

import Button from "@cayuse/shared-react.components.button";
import FormattedDate from "@cayuse/shared-react.components.formatted-date";
import { get } from "lodash";

import { isNonEmptyObject } from "@cayuse/shared-react.utils.type-checks";

import { FlowableCombobox } from "components/flowable/FlowableCombobox";
import { useDictionary } from "hooks";
import { tenantSelectors } from "store/selectors";

import styles from "../styles.css";
import { useFundingProgramContext } from "../useFundingProgramContext";


export const RoundsBlock = ({ programIndex }) => {
	const fundingSchemeDictionary = useSelector(tenantSelectors.useFundingSchemeDictionary);
	const dictionary = useDictionary(`${fundingSchemeDictionary ? "fundingScheme" : "fundingProgram"}.form.roundsBlock`);
	const ctx = useFundingProgramContext({ programIndex });

	React.useEffect(() => {
		if (ctx.current.round?.value) {
			ctx.loadRoundByIdAndUpdateCurrent(ctx.current.round.value);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ ctx.current.round?.value ]);

	if (ctx.current.round === null) {
		return <div data-testid="empty-rounds-block" />;
	}

	return (
		<div className={styles.block} data-testid="rounds-block">
			<FlowableCombobox
				disabled={ctx.disabled}
				label={dictionary.inputLabel}
				placeholder={dictionary.inputPlaceholder}
				required={ctx.config.isRequired}
				loadOptions={ctx.loadRoundOptions}
				onFocus={ctx.onFocus}
				onBlur={ctx.onBlur}
				onChange={ctx.onSelectRound}
				backspaceRemovesValue={false}
				value={ctx.current.round?.value ? ctx.current.round : null}
				invalid={ctx.touched && get(ctx.errors, `${programIndex}.round`)}
				loadingMessage="Loading..."
			/>
			<table className={`ui table ${styles.table} ${styles.roundsTable}`}>
				<thead>
					<tr>
						<th>{dictionary.tableColumns[0]}</th>
						<th>{dictionary.tableColumns[1]}</th>
						<th>{dictionary.tableColumns[2]}</th>
						<th>{dictionary.tableColumns[3]}</th>
						<th>{dictionary.tableColumns[4]}</th>
					</tr>
				</thead>
				<tbody>
					{isNonEmptyObject(ctx.current.round.item)
						? (
							<tr>
								<td>{ctx.current.round.item.name}</td>
								<td>{ctx.current.round.item.year}</td>
								<td><FormattedDate date={String(ctx.current.round.item.internalClosingDate).replace("Z", "")} /></td>
								<td><FormattedDate date={String(ctx.current.round.item.externalClosingDate).replace("Z", "")} /></td>
								<td>{ctx.current.round.item.active ? "Yes" : "No"}</td>
							</tr>
						) : (
							<tr data-empty="true">
								<td colSpan="5">{dictionary.emptyTable}</td>
							</tr>
						)}
				</tbody>
			</table>

			<Button
				icon="trash"
				secondary
				className={styles.add}
				onClick={ctx.onRemoveRound}
				data-testid="remove-round-btn"
				disabled={ctx.disabled}
				onFocus={ctx.onFocus}
				onBlur={ctx.onBlur}
			>
				{dictionary.removeRoundButton}
			</Button>
		</div>
	);
};
